// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"93aef916","453":"88b152cf"}[chunkId] + ".chunk.js";
};